export interface ILogListItem {
    id: string;
    type: number;
    typeStr: string;
    version: string;
    callerIp: string;
    companyCode: string;
    userCode: string;
    operation: string;
    action: string;
    parameters: string;
    message: string;
    modifyDate: number;
    browserInfo: string;
}

export class LogListItem implements ILogListItem {
    id: string;
    type: number;
    typeStr: string;
    version: string;
    callerIp: string;
    companyCode: string;
    userCode: string;
    operation: string;
    action: string;
    parameters: string;
    message: string;
    modifyDate: number;
    browserInfo: string;

    constructor();
    constructor(obj: ILogListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.type = obj && obj.type || 1;
        this.typeStr = obj && obj.typeStr || "";
        this.version = obj && obj.version || "";
        this.callerIp = obj && obj.callerIp || "";
        this.companyCode = obj && obj.companyCode || "";
        this.userCode = obj && obj.userCode || "";
        this.operation = obj && obj.operation || "";
        this.action = obj && obj.action || "";
        this.parameters = obj && obj.parameters || "";
        this.message = obj && obj.message || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.browserInfo = obj && obj.browserInfo || "";
    }
}